import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

/**
 * Note: StrictMode intentionally double-invokes effects in development
 * to help detect side effects and ensure components are resilient.
 * This may cause duplicate API calls in development but won't happen in production.
 * 
 * We've implemented request deduplication in the service layer to handle this.
 * See: src/utils/requestCache.ts
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
